<template>
    <a href="#" :class="['add-to-jinglebox', {on: status}]" @click.prevent="toggleSelectionItem"></a>
</template>


<script>
    export default {
        props: {
            id: {
                type: String,
                required: true,
            },
            active: {
                type: Boolean,
                default: false,
            },
            defaultLanguage: {
                type: String,
                default: 'en',
            },
            language: {
                type: String,
                default: 'en',
            },
        },
        data() {
            return {
                status: false
            }
        },
        methods: {
            toggleSelectionItem() {
                axios
                    .post((this.language != this.defaultLanguage ? '/' + this.language : '') + '/jinglebox/update-selection', {toggleId: this.id})
                    .then((response) => {
                        if (response.data.hasOwnProperty('selection')) {
                            let nowActive = false;

                            for (let s in response.data.selection) {
                                if (response.data.selection[s].id == this.id) {
                                    nowActive = true;
                                    break;
                                }
                            }

                            this.$root.$emit('jingleboxCount', response.data.selection.length);

                            this.status = nowActive;
                        }
                    });
            },
        },
        mounted: async function() {
            this.status = this.active;
        },
    }
</script>
